import React from "react";
import { references } from "../mock";

const References = () => {
  return (
    <section className="py-16 md:py-24 bg-white border-t border-neutral-100">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-3 gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-brand uppercase mb-4">
              Références
            </p>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-neutral-900 leading-tight">
              Ils nous font <span className="text-brand">confiance.</span>
            </h2>
            <p className="mt-5 text-neutral-600 leading-relaxed">
              Des entreprises industrielles, des groupes du BTP et des sites
              tertiaires nous renouvellent leur confiance pour l'entretien de
              leurs locaux et chantiers.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-3 border border-neutral-200 rounded-2xl overflow-hidden">
              {references.map((r, i) => (
                <div
                  key={r.name}
                  className={`flex items-center justify-center p-10 bg-white hover:bg-neutral-50 transition-colors ${
                    i < references.length - 1 ? "sm:border-r border-neutral-200" : ""
                  }`}
                >
                  <img
                    src={r.logo}
                    alt={r.name}
                    className="max-h-14 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs font-medium tracking-widest text-neutral-400 uppercase">
              ↳ Et d'autres entreprises des Hauts-de-France & de l'industrie
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default References;
